<template>
  <div class="wizard">
    <div class="main">
      <div class="taxgift-intro">
        <p>
          <b>{{ $t("integration.admire_title", "Admire") }}</b>
        </p>
      </div>
      <b-form-group
        id="reports-fieldset-select-entity"
        label="API Key:"
        label-for="reports-input-select-entity"
      >
        <b-form-input
          id="reports-input-select-entity"
          v-model="key"
          type="text"
          placeholder="Please enter your API Key"
          required
        ></b-form-input>
      </b-form-group>
      <admire-campaign-select v-model="campaignSelection" />

      <b-form-group id="reports-fieldset-select-entity">
        <b-form-checkbox v-model="sandbox" name="check-button" switch> Sandbox </b-form-checkbox>
      </b-form-group>

      <b-form-group id="reports-fieldset-send-as-pledged-installments">
        <b-form-checkbox v-model="sendAsPledgedInstallments" name="check-button" switch>
          {{
            $t("integration.admire_send_as_pledged_installments", "Send as pledged installments")
          }}
        </b-form-checkbox>
      </b-form-group>

      <admire-payment-method-mapping
        v-model="paymentMethodMapping"
        @confirmed-change="paymentMappingConfirmed = $event"
      />

      <p>
        {{
          $t(
            "integration.admire_description",
            "Recurring we send it over to Admire as a recurring schedule pledge only (this would import the initial billed transaction and also create the schedule as a pledge only within Admire) and the client would then download the matching payment transactions out of Banquest each month and apply to the recurring pledges in Admire."
          )
        }}
      </p>
    </div>
    <div class="footer">
      <button class="bttn bttn--lg bttn--blue" @click.prevent="closeModal">
        {{ $t("integration.close") }}
      </button>
      <button
        class="bttn bttn--lg bttn--orange el-right"
        :disabled="!key || !paymentMappingConfirmed || !campaignValid"
        @click.prevent="addIntegration"
      >
        {{ $t("integration.add_taxgift", "Add Integration") }}
      </button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import urls from "@/constants/urls.js";
import { mapState } from "vuex";
import AdmirePaymentMethodMapping from "./admirePaymentMethodMapping.vue";
import AdmireCampaignSelect from "./admireCampaignSelect.vue";

export default {
  components: {
    AdmirePaymentMethodMapping,
    AdmireCampaignSelect,
  },

  data() {
    return {
      key: "",
      sandbox: false,
      sendAsPledgedInstallments: false,
      paymentMethodMapping: {},
      paymentMappingConfirmed: false,
      campaignSelection: { campaignIds: [], campaignSyncPending: false },
    };
  },

  computed: {
    ...mapState({
      orgId: () => {
        return localStorage.getItem("orgId");
      },
    }),

    campaignValid() {
      return (
        this.campaignSelection.campaignIds.length > 0 || this.campaignSelection.campaignSyncPending
      );
    },
  },

  methods: {
    closeModal() {
      this.$store.dispatch("getIntegrationsList");
      this.$emit("close-modal");
    },
    addIntegration() {
      const payload = {
        key: this.key,
        status: true,
        sandbox: this.sandbox,
        send_as_pledged_installments: this.sendAsPledgedInstallments,
        payment_method_mapping: this.paymentMethodMapping,
        autoexport_for_campaigns: this.campaignSelection.campaignIds,
        campaign_sync_pending: this.campaignSelection.campaignSyncPending,
      };
      // Please fill in API Call here
      axios
        .post(urls.addIntegration(this.orgId, "admire"), payload)
        .then(() => {
          this.$_notificationsMixin_makeToast("Success", this.$t("account.success_edit"));
          this.$emit("close-modal");
          this.$store.dispatch("getIntegrationsList");
        })
        .catch(this.$_notificationsMixin_handleCatch);
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  display: flex;
  justify-content: space-between;
}
.el-right {
  margin-left: auto;
}
</style>
